import { FC, useContext } from 'react';
import BackCardLayout from '../../layout/BackCardLayout/BackCardLayout';
import GlobalContext from '../../contexts/GlobalContext';
import styles from './MigrateStaffAccountPassword.module.scss';
import common from '../../util/scss/common.module.scss';
import PasswordInput from '../PasswordInput/PasswordInput';
import PasswordValidator from '../PasswordValidator/PasswordValidator';
import MigrateStaffAccountContext, { EMigrateStaffAccountUiState } from '../../contexts/MigrateStaffAccountContext';
import { LoadingButton } from '@mui/lab';
import { Alert } from '@mui/material';

const MigrateStaffAccountPassword: FC = () => {
    const { language } = useContext(GlobalContext);
    const {
        migrateStaffAccountUiState,
        password,
        passwordIsValid,
        setPassword,
        setPasswordHasFocus,
        setPasswordHasValidated,
        password2,
        setPassword2,
        password2IsValid,
        password2ValidationMessage,
        setPassword2HasValidated,
        setPassword2HasFocus,
        disablePasswordSubmit,
        submitMigrateAccount,
    } = useContext(MigrateStaffAccountContext);

    const handlePasswordFocus = () => {
        setPasswordHasFocus(true);
    };

    const handlePassword2Focus = () => {
        setPassword2HasFocus(true);
    };

    const handlePasswordBlur = () => {
        setPasswordHasValidated(true);
        setPasswordHasFocus(false);
    };

    const handlePassword2Blur = () => {
        setPassword2HasValidated(true);
        setPassword2HasFocus(false);
    };

    const handleSubmitResetPassword = (event) => {
        event.preventDefault();
        submitMigrateAccount();
    };

    return (
        <BackCardLayout>
            <header>
                <h1 className={common.pageHeader}>
                    {language.staffAccountMigration.password.title}
                    <br />
                    {language.staffAccountMigration.password.subtitle}
                </h1>
                <p className={common.pageSubhead}>{language.staffAccountMigration.password.subhead}</p>
            </header>
            {migrateStaffAccountUiState === EMigrateStaffAccountUiState.softError && (
                <section className={common.genericError}>
                    <Alert severity="error">{language.validation.genericError}</Alert>
                </section>
            )}
            <form>
                <main>
                    <PasswordInput
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        error={!passwordIsValid}
                        label={language.common.password}
                        onFocus={handlePasswordFocus}
                        onBlur={handlePasswordBlur}
                        autoFocus={true}
                    />
                    <section className={styles.passwordValidatorBlock}>
                        <div className={styles.passwordValidator}>
                            <PasswordValidator password={password} />
                        </div>
                    </section>
                    <PasswordInput
                        value={password2}
                        onChange={(event) => setPassword2(event.target.value)}
                        error={!password2IsValid}
                        label={language.staffAccountMigration.password.confirmPassword}
                        onFocus={handlePassword2Focus}
                        onBlur={handlePassword2Blur}
                        helperText={!passwordIsValid && password2ValidationMessage}
                    />
                </main>
                <footer className={styles.resetPasswordCTA}>
                    <LoadingButton
                        variant="contained"
                        type="submit"
                        data-testid="migrate-staff-password"
                        disabled={
                            disablePasswordSubmit || migrateStaffAccountUiState === EMigrateStaffAccountUiState.loading
                        }
                        loading={migrateStaffAccountUiState === EMigrateStaffAccountUiState.loading}
                        onClick={handleSubmitResetPassword}
                        size="large"
                    >
                        {language.staffAccountMigration.password.confirmPassword}
                    </LoadingButton>
                </footer>
            </form>
        </BackCardLayout>
    );
};

export default MigrateStaffAccountPassword;
